import React from 'react';
import { string } from 'prop-types';
import Desktop from './Desktop/Desktop';
import Mobile from './Mobile/Mobile';

const propTypes = {
  id: string.isRequired
};

const Rating = ({ id, heightSm }) => {
  const isMobile = window.innerWidth < 992;

  const ratingProps = {
    header: 'Rating',
    content:
      'Safety is JetSuite’s top priority and the foundation of our world-class private travel experience. Independent safety auditors ARG/US gave JetSuite a PLATINUM rating, the highest achievable in civil aviation, and an accolade bestowed on fewer than 5% of charter operators nationwide. In addition to IS-BAO approval and compliance, JetSuite’s ceaseless commitment to safety has been recognized by the FAA’s Diamond Award of Excellence and NATA’s Five Star Award.'
  };

  return isMobile ? (
    <Mobile id={id} ratingProps={ratingProps} />
  ) : (
    <Desktop id={id} ratingProps={ratingProps} heightSm={heightSm} />
  );
};

Rating.propTypes = propTypes;

export default Rating;



// WEBPACK FOOTER //
// ./src/components/Safety/Rating/Rating.jsx